import {AlarmAnalysisState} from "../types";
import {Reducer} from "redux";
import * as Routines from "../routines";
import { MapActionTypes } from "../actionTypes";

const alarmAnalysis: Reducer<AlarmAnalysisState> = (state: AlarmAnalysisState = {}, action) => {
  switch (action.type) {
    case Routines.alarmAnalysis.SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload.analysis
      };

    case MapActionTypes.RESET_STATE:{
      return {}
    }

    default:
      return state;
  }
};

export default alarmAnalysis;
